import $ from "jquery";
import select2 from "select2";

select2($);

$(function () {
	$(".select2-org-categories").select2({
		width: "100%",
		placeholder: "Select categories",
		closeOnSelect: false,
		allowClear: true,
	});
});
